import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import {
  LotVersionsFragment,
  LotViewsFragment,
  UserLotQuery,
} from '../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-events-modal',
  templateUrl: './lot-events-modal.component.html',
  styleUrls: ['./lot-events-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotEventsModalComponent {
  @Input() lot: LotVersionsFragment & LotViewsFragment;

  @Input()
  @HostBinding('class.full-size')
  fullSize = false;

  @HostBinding('style.display')
  display: 'none' | 'inline-block' = 'none';

  isVisible = false;

  @Input()
  set currentUser(currentUser: UserLotQuery['currentUser']) {
    this.display = currentUser.isAuctioneer ? 'inline-block' : 'none';
  }
}
